module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head-nav",
    attrs: {
      "id": "header_container"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('el-col', {
    staticClass: "logo-container",
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("加阳华枫快运")])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('i', {
    staticClass: "fa fa-sign-out logout",
    on: {
      "click": _vm.logout
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryP),
      expression: "deliveryP"
    }],
    staticClass: "welcome"
  }, [_c('p', {
    staticClass: "deliveryP"
  }, [_vm._v("派送点：\n                    " + _vm._s(_vm.deliveryP))])])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../assets/img/avatar.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "welcome"
  }, [_c('p', {
    staticClass: "name comename"
  }), _vm._v(" "), _c('p', {
    staticClass: "name avatarname"
  }, [_vm._v(_vm._s(_vm.userName) + "  " + _vm._s(_vm.realeName))])])]), _vm._v(" "), _c('div', {
    staticClass: "notify-row"
  }, [_c('ul', {
    staticClass: "top-menu"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e69bf84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/headNav.vue
// module id = 1251
// module chunks = 2